import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Masonry from 'react-masonry-css';
import { Link } from 'react-router-dom';
import LoadingOverlay from 'react-loading-overlay';
import { useInfiniteScroll } from 'react-infinite-scroll-hook';
import { map } from 'lodash';
import VideoThumbnail from 'react-video-thumbnail';
import ReactImageFallback from 'react-image-fallback';
import {
  loaderStyle, FACEBOOK_BLACK_ICON, INSTA_BLACK_ICON, SPOTIFY_BLACK_ICON, YOUTUBE_BLACK_ICON,
  TWITTER_BLACK_ICON, routeConstants, NUMERIC_VALUE, getTimeAgoFormat, MEDIA_VIEW_TYPE, staticConstants, MediaRender, capitalizeEveryWord, FALLBACK_ICON, OFFER_ICON,
} from '../../../utils';
import MediaPopup from '../../modals/MediaPopup';

function Analytics(props) {
  const {
    analyticsData, analyticsDataLoading, infiniteScroll, currentPage,
  } = props;
  const [existingAnalyticsList, setExistingAnalyticsList] = useState([]);
  const [mediaPopup, setMediaPopup] = useState(false);
  const [mediaItem, setMediaItem] = useState();
  const [hasNextPage, setHasNextPage] = useState(false);
  const breakpointColumnsObj = {
    default: 3,
    1100: 3,
    700: 2,
    500: 1,
  };

  useEffect(() => {
    if (analyticsData && analyticsData.data.length > 0) {
      setHasNextPage(analyticsData.hasNextData);
      const dataList = analyticsData.data;
      setExistingAnalyticsList(currentPage === NUMERIC_VALUE.ONE ? dataList : existingAnalyticsList.concat(dataList));
      props.setTotalCount(analyticsData.count);
    }
  }, [analyticsData]);

  const renderSocialMediaIcons = (sharedPost) => {
    const imageToReturn = [];
    if (sharedPost.instagramUrl) {
      imageToReturn.push(
        <span className="ml-3">
          <a href={sharedPost.instagramUrl} target="_blank" rel="noopener noreferrer">
            <img
              src={INSTA_BLACK_ICON}
              alt="instagram"
            />
          </a>
        </span>,
      );
    }
    if (sharedPost.facebookUrl) {
      imageToReturn.push(
        <span className="analytics-icon">
          <a href={sharedPost.facebookUrl} target="_blank" rel="noopener noreferrer">
            <img
              src={FACEBOOK_BLACK_ICON}
              alt="facebook"
            />
          </a>
        </span>,
      );
    }
    if (sharedPost.twitterUrl) {
      imageToReturn.push(
        <span className="analytics-icon">
          <a href={sharedPost.twitterUrl} target="_blank" rel="noopener noreferrer">
            <img
              src={TWITTER_BLACK_ICON}
              alt="twitter"
            />
          </a>
        </span>,
      );
    }
    if (sharedPost.youtubeUrl) {
      imageToReturn.push(
        <span className="analytics-icon">
          <a href={sharedPost.youtubeUrl} target="_blank" rel="noopener noreferrer">
            <img
              src={YOUTUBE_BLACK_ICON}
              alt="twitter"
            />
          </a>
        </span>,
      );
    }
    if (sharedPost.spotifyUrl) {
      imageToReturn.push(
        <span className="analytics-icon">
          <a href={sharedPost.spotifyUrl} target="_blank" rel="noopener noreferrer">
            <img
              src={SPOTIFY_BLACK_ICON}
              alt="spotify"
            />
          </a>
        </span>,
      );
    }
    return imageToReturn;
  };

  const renderImageOrVideo = (mediaObj, mediaFile) => {
    switch (mediaFile.mediaType) {
      case MEDIA_VIEW_TYPE.IMAGE:
        return mediaObj;
      case MEDIA_VIEW_TYPE.VIDEO:
        return (
          <>
            <VideoThumbnail
              videoUrl={mediaFile.url}
            />
          </>
        );
      default:
        break;
    }
    return null;
  };

  const openMediaPopup = (item) => {
    setMediaPopup(true);
    setMediaItem(item);
  };

  const toggleMediaModal = () => {
    setMediaPopup(!mediaPopup);
  };

  function handleLoadMore() {
    infiniteScroll(currentPage + NUMERIC_VALUE.ONE, NUMERIC_VALUE.THREE);
  }

  const infiniteRef = useInfiniteScroll({
    loading: analyticsDataLoading,
    hasNextPage,
    onLoadMore: handleLoadMore,
    scrollContainer: 'window',
  });

  const renderBetaPosts = () => {
    if (analyticsData) {
      return map(existingAnalyticsList, (item) => {
        const artistInfo = item && item.userId;
        const offerObj = item && item.offerId;
        return item && (
          <div className="analytics-card" key={item.approvedDate}>
            <div className="analytics-card-head">
              <div className="analytics-card-head-user">
                <span className={`card-head-user-icon ${item.isNotification ? 'notify' : ''}`}>
                  <ReactImageFallback
                    src={artistInfo.artistImage}
                    fallbackImage={FALLBACK_ICON}
                    className="image-cover"
                    alt="User"
                  />
                </span>
                <div className="analytics-card-head-user-detail">
                  <h3>{capitalizeEveryWord(artistInfo.name)}</h3>
                  <p>
                    {`Posted ${getTimeAgoFormat(item.approvedDate)}`}
                  </p>
                </div>
                <div className="analytics-card-head-user-icons">
                  {renderSocialMediaIcons(item.sharedPost).map((ele) => ele)}
                </div>
              </div>
            </div>
            {(item.media.length || item.betaPostInfo)
              ? (
                <>
                  <div className="analytics-card-media-wrapper">
                    {MediaRender(item.media).map((obj) => (
                      <div
                        className="analytics-card-media"
                        onClick={() => openMediaPopup(obj && obj.file)}
                      >
                        {renderImageOrVideo(obj.media, obj.file)}
                      </div>
                    ))}
                  </div>
                  <p
                    className="analytics-card-description"
                  >
                    {item.betaPostInfo}
                  </p>
                </>
              ) : <p className="py-4 text-center w-100">Click on social media icon(s) to view posts</p> }
            <div className="analytics-card-btn-group">
              <Link
                className={`btn btn-blank ${!offerObj ? 'pointer-none' : ''}`}
                to={`${routeConstants.ADMIN_CAMPAIGN}/${offerObj && offerObj._id}/${artistInfo && artistInfo._id}`}
                target="_blank"
                element="block"
              >
                Campaign timeline
              </Link>
              <span>
                <Link
                  className={!offerObj ? 'pointer-none' : ''}
                  to={{
                    pathname: `${routeConstants.OFFER_DETAIL}/${(offerObj && offerObj._id)}`,
                    state: { isFrom: staticConstants.COMPONENT_KEYWORDS.ADMIN_ANALYTICS_PAGE },
                  }}
                >
                  See opportunity
                </Link>
              </span>
            </div>
          </div>
        );
      });
    }
    return null;
  };

  return (
    <>
      <div className="content-wrapper-box">
        <LoadingOverlay
          active={analyticsDataLoading}
          spinner
          text=""
          className="analyticsListContainerLoader"
          styles={loaderStyle}
        />
        <div ref={infiniteRef}>
          <div className="analytics-list">
            <div className="analytics-list-wrapper">
              <Masonry
                breakpointCols={breakpointColumnsObj}
                className="dashboard-cards"
                columnClassName="bm-masonry-grid-column"
              >
                {renderBetaPosts()}
              </Masonry>
              {analyticsData && analyticsData.data && analyticsData.data.length === 0 && (
                <div className="no-offer-section analytics-no-offer">
                  <div className="no-offer-content d-block">
                    <img
                      src={OFFER_ICON}
                      alt="Offer"
                    />
                    <h1>No posts yet!</h1>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
      {mediaPopup && (
      <MediaPopup
        isOpen={mediaPopup}
        onClose={() => { toggleMediaModal(); }}
        timelineData={mediaItem}
      />
      )}
    </>
  );
}
export default Analytics;

Analytics.propTypes = {
  analyticsData: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.shape({
      betaPostInfo: PropTypes.string,
      media: PropTypes.arrayOf(PropTypes.shape({
        _id: PropTypes.string,
        url: PropTypes.string,
        thumbnail: PropTypes.string,
        mediaType: PropTypes.string,
      })),
      shareType: PropTypes.shape({
        facebook: PropTypes.bool,
        instagram: PropTypes.bool,
        twitter: PropTypes.bool,
        spotify: PropTypes.bool,
        youtube: PropTypes.bool,
      }),
      sharedPost: PropTypes.shape({
        facebook: PropTypes.bool,
        instagram: PropTypes.bool,
        twitter: PropTypes.bool,
        spotify: PropTypes.bool,
        youtube: PropTypes.bool,
        facebookUrl: PropTypes.string,
        instagramUrl: PropTypes.string,
        twitterUrl: PropTypes.string,
        spotifyUrl: PropTypes.string,
        youtubeUrl: PropTypes.string,
      }),
      _id: PropTypes.string,
      offerId: PropTypes.shape({
        title: PropTypes.string,
        clientName: PropTypes.string,
        _id: PropTypes.string,
      }),
      approvedDate: PropTypes.string,
    })),
    count: PropTypes.number,
    hasNextData: PropTypes.bool,
  }),
  setTotalCount: PropTypes.func,
  analyticsDataLoading: PropTypes.bool.isRequired,
  infiniteScroll: PropTypes.func.isRequired,
  currentPage: PropTypes.number.isRequired,
};

Analytics.defaultProps = {
  analyticsData: null,
  setTotalCount: null,
};
